import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  PostBoardInvitationsRequestParams,
  PostBoardInvitationsResponse,
} from '../types';

export const postBoardInvitations = async ({
  path: { organisationId, boardId },
  body,
}: PostBoardInvitationsRequestParams) => {
  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}/invitations`;
  const { data } = await apiAuthClient.post<PostBoardInvitationsResponse>(
    url,
    body,
  );
  return data.data;
};
